<template>
  <!-- Główny kontener z klasami flex-column (ustawia wszystko pionowo) -->
  <div class="tickets content-container flex-column">
    <div class="content-wrap">

      <!-- Górny pasek menu bez treści po lewej (tickets-section), po prawej TopMenu -->
      <div class="d-flex tickets-section-container no-content">
        <div class="tickets-section"></div>
        <div class="content-wrap">
          <TopMenu />
        </div>
      </div>

      <!-- Druga sekcja - faktyczna lista ticketów/reports -->
      <div class="d-flex tickets-section-container">
        <!-- Lewy panel sekcji -->
        <div class="tickets-section">
          <span>
            {{ t('reports-list') }}
          </span>
        </div>

        <!-- Prawa kolumna - właściwa treść (nagłówek + lista ticketów) -->
        <div class="content-wrap">
          <h3>{{ t('reports').toUpperCase() }}</h3>
          <div class="collapse show" id="addUser">
            <!-- Komponent obsługujący listę ticketów Zammad -->
            <Tickets />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Importujemy górne menu oraz komponent z listą ticketów
import TopMenu from "../components/TopMenu.vue";
import Tickets from "@/components/Tickets";
import { useI18n } from "vue-i18n";

export default {
  name: "HomeView", // Nazwa komponentu
  components: {
    Tickets, // rejestrujemy komponent z ticketami
    TopMenu,       // rejestrujemy górne menu
  },
  data() {
    return {
      // Można tu trzymać dane do tego widoku, jeśli będą potrzebne
    };
  },
  methods: {
    // Miejsce na metody - na razie nieużywane
  },
  setup() {
    const { t } = useI18n();
    return { t }
  },
};
</script>

<style scoped>
/* Kontener sekcji */
.tickets-section-container {
  width: 100%;
}

/* Lewy panel sekcji (np. tło z obrazkiem) */
.tickets-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.tickets-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

/* Ikona do zwijania/rozwijania - tu nie jest używana, zostawiona na przyszłość */
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}

/* Styl nagłówka sekcji po prawej */
.content-wrap h3 {
  padding: 15px 25px;
  background-color: white;
}

.content-container > div{
  min-height: auto !important;
}
</style>
